export const sunday = [
  { hour: "7:00" },
  { hour: "9:00" },
  { hour: "10:30", info: "(dla dzieci)" },
  { hour: "12:00" },
  { hour: "18:00" },
];

export const day = [
  { hour: "7:00" },
  { hour: "17:00", info: "(od października do czerwca)" },
  { hour: "18:00" },
];

export const liturgyImage = "./assets/holy-chalice_3975495.webp"
